const filterNodes = {
    gridsContainer: document.getElementById('products-listing'),
    paginationParent: document.querySelector('[data-paginationParent]')
  }
  
  class CollectionFilters {
    constructor() {
      this.dynamicEleEvents();
      this.init();
    }
  
    dynamicEleEvents() {
  
      const paginationLinks = document.querySelectorAll('[data-pagelinks]');
      paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));
    }

    init() {
    
      if(document.querySelector('[data-haslink]') != null){
        document.querySelector('[data-haslink]').addEventListener('click', (evt) => {
          evt.stopPropagation();
          evt.target.closest('li').classList.toggle('open');
        });
      }
    }
    
    /**
     * 
     * @param {String} url URL for fetching results
     * @param {String} type filter / pagination / sub_collection
     */
    renderGridFromFetch(url, type) {
      if(!url) return;
  
      let sectionID = document.getElementById('products-listing').dataset.id;
      if(type == 'sub_collection'){
        url += `&sections=${sectionID},template-collection-banner`;
      }else{
        url += `&sections=${sectionID}`;
      }
     
      fetch(url)
        .then(response => response.json())
        .then((response) => {
          let gridHTML = response[sectionID];
          let bannerHTML = response['template-collection-banner'];
          this.renderProductGrid(type, gridHTML, bannerHTML);
        });
    }
  
    /**
     * 
     * @param {HTMlResponse} html 
     * @param {String} type filter / pagination / sub_collection
     */
    renderProductGrid(type, grid, banner) {
      const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
      let paginationType = (filterNodes.paginationParent) ? filterNodes.paginationParent.dataset.type : 'numbers';
  
      if(type == 'pagination' && paginationType == 'loadmore'){
        let productGrids = filterNodes.gridsContainer.querySelector('#product-grids');
        productGrids.insertAdjacentHTML('beforeend', collectionParent.querySelector('#product-grids').innerHTML);
  
        let loadMoreBtn = document.getElementById('load-more');
        if(collectionParent.getElementById('load-more') && loadMoreBtn){   
          loadMoreBtn.parentNode.replaceChild(collectionParent.getElementById('load-more'), loadMoreBtn); 
        }else if(loadMoreBtn){
          loadMoreBtn.remove();
        }
      }else{
        const gridsHTML = collectionParent.getElementById('products-listing').innerHTML;
        filterNodes.gridsContainer.innerHTML = gridsHTML;
      }

      this.dynamicEleEvents();
    } 
    
    /**
     * 
     * @param {event} event 
     */
    _managePagination(event){
      event.preventDefault();
      let _this = event.currentTarget;
      this.renderGridFromFetch(_this.href, 'pagination');
  
      let paginationType = _this.closest('[data-paginationparent]').dataset.type;
      if(paginationType != 'loadmore'){
        setTimeout(() => {
          history.pushState({}, '', _this.href);
        }, 500);
      }
    }
  
  }
  typeof CollectionFilters !== 'undefined' && new CollectionFilters();
  